export const types = {
  OPEN_POPUP: 'OPEN_POPUP',
  CLOSE_POPUP: 'CLOSE_POPUP'
}



// WEBPACK FOOTER //
// ./src/features/popup/store/types.js